const types = {
	SET_USER_REQUEST_DATA: 'SET_USER_REQUEST_DATA',
}

export default types;
